// extracted by css-extract-rspack-plugin
export default {"item":"SelectItem-module__item___g9syb","selected":"SelectItem-module__selected___RbwdW","disabled":"SelectItem-module__disabled___LUWHl"};